import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  type: 'schedule-trigger',
  name: 'Schedule Trigger',
  category: 'triggers',
  description: 'Trigger workflows on a schedule using cron expressions or intervals',
  icon: 'Clock',
  color: 'purple',
  version: '1.1.0',
  
  group: ['trigger', 'schedule'],
  
  defaults: {
    name: 'Schedule Trigger',
    color: '#a855f7'
  },
  
  subtitle: '={{ $parameter.triggerTimes?.item?.[0]?.mode === "everyXMinutes" ? "Every " + ($parameter.triggerTimes?.item?.[0]?.minuteInterval || 15) + " min" : $parameter.triggerTimes?.item?.[0]?.mode === "everyHour" ? "Every hour at :" + String($parameter.triggerTimes?.item?.[0]?.minute || 0).padStart(2, "0") : $parameter.triggerTimes?.item?.[0]?.mode === "everyXHours" ? "Every " + ($parameter.triggerTimes?.item?.[0]?.hourInterval || 2) + " hours" : $parameter.triggerTimes?.item?.[0]?.mode === "everyDay" ? "Daily at " + String($parameter.triggerTimes?.item?.[0]?.hour || 9).padStart(2, "0") + ":" + String($parameter.triggerTimes?.item?.[0]?.minute || 0).padStart(2, "0") : $parameter.triggerTimes?.item?.[0]?.mode === "everyWeek" ? "Weekly on " + ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"][$parameter.triggerTimes?.item?.[0]?.dayOfWeek || 1] + " at " + String($parameter.triggerTimes?.item?.[0]?.hour || 9).padStart(2, "0") + ":" + String($parameter.triggerTimes?.item?.[0]?.minute || 0).padStart(2, "0") : $parameter.triggerTimes?.item?.[0]?.mode === "everyMonth" ? "Monthly on day " + ($parameter.triggerTimes?.item?.[0]?.dayOfMonth || 1) + " at " + String($parameter.triggerTimes?.item?.[0]?.hour || 9).padStart(2, "0") + ":" + String($parameter.triggerTimes?.item?.[0]?.minute || 0).padStart(2, "0") : $parameter.triggerTimes?.item?.[0]?.mode === "custom" ? ($parameter.triggerTimes?.item?.[0]?.cronExpression || "Custom cron") : "Every hour" }}',
  
  inputs: [],
  
  outputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Main'
    }
  ],
  
  tags: ['schedule', 'cron', 'timer', 'interval', 'recurring'],
  
  comingSoon: false,
  
  metadata: {
    documentation: 'https://docs.n8n.io/integrations/builtin/core-nodes/n8n-nodes-base.scheduletrigger/'
  }
};

export default definition;
